/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Findings_TitleInputs */

const en_us2_draft_findings_title = /** @type {(inputs: Draft_Findings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What this plan could not do`)
};

const pt_br2_draft_findings_title = /** @type {(inputs: Draft_Findings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que este plano não conseguiu fazer`)
};

const es_419_draft_findings_title = /** @type {(inputs: Draft_Findings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo que este plan no pudo hacer`)
};

const pt_pt2_draft_findings_title = /** @type {(inputs: Draft_Findings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que este plano não conseguiu fazer`)
};

const fr_fr2_draft_findings_title = /** @type {(inputs: Draft_Findings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce que ce programme n'a pas pu faire`)
};

const de_de2_draft_findings_title = /** @type {(inputs: Draft_Findings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was dieser Plan nicht leisten konnte`)
};

const it_it2_draft_findings_title = /** @type {(inputs: Draft_Findings_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa questa scheda non è riuscita a fare`)
};

/**
* | output |
* | --- |
* | "What this plan could not do" |
*
* @param {Draft_Findings_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_findings_title = /** @type {((inputs?: Draft_Findings_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Findings_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_findings_title(inputs)
	if (locale === "es-419") return es_419_draft_findings_title(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_findings_title(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_findings_title(inputs)
	if (locale === "de-DE") return de_de2_draft_findings_title(inputs)
	if (locale === "it-IT") return it_it2_draft_findings_title(inputs)
	return en_us2_draft_findings_title(inputs)
});
export { draft_findings_title as "draft.findings_title" }